var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message-filter-group" },
    [
      _vm.showRemoveButton
        ? _c("div", { staticClass: "control-buttons" }, [
            _c(
              "div",
              { staticClass: "control-button" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-icon-button md-mini",
                    on: {
                      click: function () {
                        return _vm.onRemoved(_vm.clone.id)
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("delete_outline")])],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.clone.items, function (filter, index) {
        return _c("SingleFilter", {
          key: filter.id,
          attrs: {
            "enable-operator-changed": _vm.clone.items.length > 1,
            operator: _vm.clone.operator,
            "on-operator-changed": _vm.onOperatorChanged,
            selected: filter.id === _vm.selectedFilterId,
            "on-selected": function () {
              return (_vm.selectedFilterId = filter.id)
            },
            "on-canceled": function () {
              return (_vm.selectedFilterId = null)
            },
            "on-removed": _vm.onFilterRemoved,
            "group-id": _vm.value.id,
            "on-group-select-hovered": function (hovered) {
              return (_vm.groupSelectHovered = hovered)
            },
            "group-select-hovered": _vm.groupSelectHovered,
            "add-filter-mode": true,
            "show-operator-select":
              _vm.clone.items.length === 1
                ? false
                : index !== _vm.clone.items.length - 1,
            "on-attribute-picked": _vm.onAttributePicked,
          },
          model: {
            value: _vm.clone.items[index],
            callback: function ($$v) {
              _vm.$set(_vm.clone.items, index, $$v)
            },
            expression: "clone.items[index]",
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }